import React from "react";
import { css } from "@emotion/react";
import { useForm } from "react-hook-form";
import { isStringEqual } from "utils";
import { useAppDispatch, useAppSelector } from "redux/Store";
import { APP_SLUGS } from "utils/constants";
import { Trans } from "react-i18next";
import { isPresente } from "utils/applicationSlug";
import { Form, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import api from "actions/api";
import { useHistory } from "hooks/useHistory";
import { hideLoginPopup } from "actions/loginPopupActions";

const formStyle = css`
  margin-bottom: 15.5px;
`;
const formStyleConsent = css`
  margin-bottom: 10px;
  margin-left: 20px;
  display: inline;
  @media (max-width: 1021px) {
    margin-bottom: -12px;
  }
`;

const inputStyle = css`
  border-radius: 5;
  background: #000000;
  border: none;
  color: #8b8b8b;
  &:focus {
    /* border-color: black; */
    box-shadow: none;
  }

  &::placeholder {
    color: #8b8b8b;
    font-size: 16px;
    opacity: 1;
  }
`;

interface IUserForm {
  name: string;
  driverId?: string;
  number?: string;
  consent: boolean;
}

interface IPhoneNumberOnlyLoginProps {
  header: string;
  logo: any;
  body: string;
  appName: string;
  textColor: string;
  bgColor: string;
  tncText?: string;
  tncLink?: string;
  hidePrivacyPolicy?: boolean;
  defaultTncLink?: boolean;
  customCheckboxElement?: any;
  style?: any;
  footerText?: any;
}

const PhoneNumberOnlyLoginForm = ({
  header,
  logo,
  body,
  appName,
  textColor,
  bgColor,
  tncLink = "",
  hidePrivacyPolicy = false,
  defaultTncLink = true,
  customCheckboxElement,
  style,
  footerText,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  tncText,
}: IPhoneNumberOnlyLoginProps) => {
  const { handleSubmit, register, errors } = useForm<IUserForm>();
  const { application, country } = useAppSelector((state: any) => state.common);
  const history = useHistory();
  const dispatch = useAppDispatch();

  const button = css`
    background-color: ${textColor};
    color: ${bgColor};
    border: none;
    margin: 0 auto;
    border-radius: 0;

    .close {
      color: white !important;
    }

    &:hover {
      background-color: ${bgColor};
      color: ${textColor};
    }
  `;

  const label = css`
    color: ${textColor};
    font-size: 15px;
    text-align: center;
    font-weight: 300;
  `;

  const baseCss = css`
    max-width: 600px;
    padding: 15px 15px;
    margin: auto;
    height: 100%;
    margin-top: 0%;
    padding-top: 0;
    .modal-header {
      padding: 8px;
    }
    @media (max-width: 1021px) {
      padding-bottom: 10px;
      padding-left: 10px;
      padding-right: 10px;
    }
    .btn-submit-container {
      text-align: center;
      margin-bottom: 25px;
      button {
        font-size: 20px;
        border-radius: 10px;
        font-weight: 700 !important;
        padding: 12px 35px;
      }
    }

    label,
    .text-style,
    .tnc-text,
    .body-text {
      color: ${textColor};
    }

    .tnc-text {
      font-size: 0.6em !important;
      margin-bottom: 0;
    }

    .header-container {
      text-align: center;
      .text-header {
        font-size: 2.3em;
        color: #ffffff;
        @media (max-width: 1021px) {
          font-size: 2em;
        }
      }
      .logo-container {
        .logo {
          width: 100%;
          height: 100%;
        }
      }
    }
  `;

  const onSubmit = async (data: any) => {
    // const paramName = encodeURI(data.name);
    // const paramUserId = encodeURI(data.mobilenumber);

    try {
      const response = await api.post("user/account/send/otp/", {
        application: application?.slug,
        phone_num: data.mobilenumber,
        country: country,
        name: data.name,
      });

      if (response) {
        // Navigate to the OTP verification page on success
        localStorage.setItem("otp-reference", response?.data?.reference);
        history.push("/verifyotp");
        dispatch(hideLoginPopup());
      } else {
        alert("Error sending OTP. Please try again."); // Handle failure
      }
    } catch (error) {
      console.error(error);
      alert("Failed to send OTP. Please try again."); // Show error message
    }

    // const BASE_URL = `${window.location.origin}/tournament?app=${application?.slug}&country=${country}&name=${paramName}&userid=${paramUserId}`;
    // window.location.replace(BASE_URL);
  };

  const rendeCheckboxLabel = () => {
    if (customCheckboxElement) {
      if (!isPresente) {
        return customCheckboxElement;
      }
    } else {
      return (
        <Form.Label className="tnc-text">
          I consent to the disclosure of my data to {appName?.toLocaleUpperCase()} through Goama Pte Ltd&apos;s game
          platform and agree to the
          {!hidePrivacyPolicy && (
            <>
              <a href="https://goama.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
              and
            </>
          )}
          <a
            href={defaultTncLink ? "https://goama.com/terms/" : tncLink || "https://goama.com/terms/"}
            target="_blank"
            rel="noopener noreferrer"
          >
            T&C{" "}
          </a>
          to collect and use it for {appName} and partner&apos;s communications.
        </Form.Label>
      );
    }
  };

  return (
    <div>
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <form onSubmit={handleSubmit(onSubmit)} css={baseCss}>
        {/* <a
          href="https://goama.com/blog/foodpanda-mobile-tournament-powered-by-goama-list-of-winners"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={banner_winner} alt="Logo" />
        </a>
        <p></p> */}
        <div className="header-container">
          <span className="text-header">{header}</span>
          <div className="logo-container">
            <img
              className="mt-1 logo"
              src={logo ? logo : application?.applicationsetting?.brand_logo}
              alt="LOGO"
              style={{
                width: "60%",
                height: "auto",
              }}
            />
          </div>
        </div>
        <p css={label}>{body}</p>
        {isStringEqual(application?.slug, APP_SLUGS.PRESENTE) && (
          <Form.Group css={formStyle}>
            <Form.Label>Nombre del jugador</Form.Label>
            <Form.Control
              css={inputStyle}
              id="TooltipName"
              type="text"
              name="name"
              key="name"
              required
              ref={register({ required: true })}
              /* ref={register({
              required: true,
               pattern: {
                value: /[a-zA-Z]+(\s[a-zA-Z]+){0,}/i,
                message: "Name must be an Alphabet"
              } 
            })} */
            />
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="TooltipName" style={{ backgroundColor: "#fa7751", color: "white" }}>
                  {errors.name?.message}
                </Tooltip>
              }
            >
              <span id="TooltipName" />
            </OverlayTrigger>
          </Form.Group>
        )}

        <Form.Group>
          <Form.Label style={{ color: "#44d62b", fontSize: "15px" }}>
            <Trans i18nKey="mobile-number">Mobile No.</Trans>
          </Form.Label>
          <Form.Control
            id="TooltipEmail"
            css={inputStyle}
            type="text"
            required
            key="mobilenumber"
            name="mobilenumber"
            placeholder="Enter your mobile no."
            ref={register({ required: true })}
          />
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="TooltipEmail" style={{ backgroundColor: "#fa7751", color: "white" }}>
                {errors.number?.message}
              </Tooltip>
            }
          >
            <span id="TooltipEmail" />
          </OverlayTrigger>
        </Form.Group>
        <br />

        {!isPresente && (
          <Form.Group css={formStyle}>
            <Form.Label style={{ color: "#44d62b", fontSize: "15px" }}>
              <Trans i18nKey="name">Name</Trans>
            </Form.Label>
            <Form.Control
              css={inputStyle}
              id="TooltipName"
              type="text"
              name="name"
              key="name"
              placeholder="Enter your name"
              required
              ref={register({ required: true })}
              /* ref={register({
              required: true,
               pattern: {
                value: /[a-zA-Z]+(\s[a-zA-Z]+){0,}/i,
                message: "Name must be an Alphabet"
              } 
            })} */
            />
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="TooltipName" style={{ backgroundColor: "#fa7751", color: "white" }}>
                  {errors.name?.message}
                </Tooltip>
              }
            >
              <span id="TooltipName" />
            </OverlayTrigger>
          </Form.Group>
        )}

        <Form.Group css={formStyleConsent}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Form.Check
              id="TooltipConsent"
              type="checkbox"
              name="consent"
              key="consent"
              required
              ref={register({
                required: true,
              })}
            />

            {/* Label beside the checkbox */}
            {rendeCheckboxLabel()}
          </div>

          {/* Tooltip under checkbox */}
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="TooltipConsent" style={{ backgroundColor: "#fa7751", color: "white" }}>
                {errors.consent?.message}
              </Tooltip>
            }
          >
            <span id="TooltipConsent" />
          </OverlayTrigger>
        </Form.Group>

        <p css={label}>{footerText}</p>

        <div className="btn-submit-container">
          <Button size="lg" type="submit" className="email-login-submit-btn" css={[button, style]}>
            <Trans i18nKey="join">Join</Trans>
          </Button>
        </div>
      </form>
    </div>
  );
};

export default PhoneNumberOnlyLoginForm;
